<script lang="ts">
  import { router } from '../lib/router.svelte';
</script>

<section class="stack">
  <h1>Transforme ta photo en kit de perles à repasser</h1>
  <p>
    Choisis une photo, une taille, un style — on fabrique le kit complet pour toi :
    les perles exactes triées par couleur, le patron imprimé, les plaques. Il ne
    reste qu'à poser.
  </p>
  <div class="stack" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: var(--space-3); margin-top: var(--space-4);">
    <button class="btn btn--primary btn--lg" type="button" onclick={() => router.navigate('order')}>
      Créer mon kit à partir d'une photo
    </button>
    <button class="btn btn--ghost" type="button" onclick={() => router.navigate('editor')}>
      Mode création libre (éditeur)
    </button>
  </div>
  <p class="hint" style="margin-top: var(--space-3);">
    Ta photo ne quitte pas ton navigateur avant la commande.
  </p>
</section>
